import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import styled from 'styled-components';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Vision from './pages/Vision';
import Worship from './pages/Worship';
import SundayWorship from './pages/SundayWorship';
import FridayPrayer from './pages/FridayPrayer';
import Sermons from './pages/Sermons';
import Community from './pages/Community';
import Admin from './pages/Admin';
import Greetings from './pages/Greetings';
import Directions from './pages/Directions';
import News from './pages/News';
import Bulletin from './pages/Bulletin';
import AdminNews from './pages/AdminNews';
import AdminMedia from './pages/AdminMedia';
import Media from './pages/Media';
import Offering from './pages/Offering';
import Youth from './pages/Youth';
import GlobalStyles from './styles/GlobalStyles';

const AppContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const MainContent = styled.main`
  flex: 1;
`;

function App() {
  return (
    <Router>
      <GlobalStyles />
      <AppContainer>
        <Header />
        <MainContent>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/vision" element={<Vision />} />
            <Route path="/worship" element={<Worship />} />
            <Route path="/sunday-worship" element={<SundayWorship />} />
            <Route path="/friday-prayer" element={<FridayPrayer />} />
            <Route path="/sermons" element={<Sermons />} />
            <Route path="/community" element={<Community />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/greetings" element={<Greetings />} />
            <Route path="/directions" element={<Directions />} />
            <Route path="/news" element={<News />} />
            <Route path="/bulletin" element={<Bulletin />} />
            <Route path="/admin/news" element={<AdminNews />} />
            <Route path="/admin/media" element={<AdminMedia />} />
            <Route path="/media" element={<Media />} />
            <Route path="/offering" element={<Offering />} />
            <Route path="/youth" element={<Youth />} />
          </Routes>
        </MainContent>
        <Footer />
      </AppContainer>
    </Router>
  );
}

export default App;
